import styled from "styled-components";
import backgroundImage from "../../assets/images/smart/main.jpg";
// import backgroundImage from '../../assets/images/windintelli_loading.png'

export const Container = styled.div`
  margin-top: 105px;
`;

export const Banner = styled.div`
  background: url(${backgroundImage}) center;
  background-size: cover;
  max-height: 450px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 450px;

    @media (max-width: 500px) {
      height: 300px;
    }

    h1 {
      color: #fff;
      font: 700 40px Roboto;
      text-align: center;
      margin: 10px;
    }
    p {
      position: relative;
      text-align: center;
      font: 400 2.5rem Roboto;
      color: #fff;
      margin: 10px;
    }
  }
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 50px auto;

  @media (max-width: 500px) {
    margin: 50px 10px;
  }

  h1 {
    color: #000;
    font: 700 40px Roboto;
    text-align: center;
  }

  h2 {
    color: #000;
    font: 400 30px Roboto;
    text-align: center;
  }
`;

export const DualContent = styled.div`
  display: flex;
  flex-basis: 0%;
  justify-content: space-evenly;
  margin: 50px 50px;

  div {
    width: 100%;
    margin: 10px 20px;
  }

  h3 {
    color: #387fa9;
    font: 500 22px Roboto;
  }
  h1 {
    margin-top: 20px;
    color: #000;
    font: 500 30px Roboto;
    text-align: left;
    line-height: 4.5rem;
  }

  ul {
    margin-left: 70px;
    li {
      color: #387fa9;
      font: 400 20px Roboto;
      list-style: none;
      margin: 0px 10px;

      & + li {
        margin: 20px 10px;
      }

      span {
        color: #000;
        font: 400 18px Roboto;
        margin-left: 20px;
        text-align: center;
      }
    }
  }

  @media (max-width: 950px) {
    flex-wrap: wrap;
    margin: 10px;
    ul {
      margin-top: 30px;
      margin-left: 0px;
    }
  }
`;

export const ApplyForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 800px;
  margin: 50px auto;
  align-self: center;
  border: 1px solid #eee;
  padding: 10px;

  h3 {
    font-size: 20px;
    padding: 25px 25px 10px 25px;
  }

  p {
    font: 400 15px Roboto;
    margin-left: 25px;
    margin-bottom: 30px;
  }

  span {
    margin-top: 40px;
    margin-left: 20px;
    color: #387fa9;
    font: 400 16px Roboto;
  }

  input {
    padding: 0 1.5rem;
    height: 4rem;
    border-radius: 0.25rem;
    border: 1px solid #e7e9ee;
    background: #fff;
    font-weight: 400;
    font-size: 1.5rem;

    margin: 1rem 20px;
    margin-bottom: 0.8rem;

    &:focus {
      outline-color: #387fa9;
    }
  }

  textarea {
    padding: 1rem 1.5rem;
    border-radius: 0.25rem;
    border: 1px solid #e7e9ee;
    background: #fff;
    font-weight: 400;
    font-size: 1.5rem;

    margin: 1rem 20px;
    margin-bottom: 0.5rem;

    &:focus {
      outline-color: #387fa9;
    }
  }

  input[type="file"] {
    border: 0;
    background: transparent;
  }
`;

export const SubmitButton = styled.button`
  margin-top: 10px;
  margin-right: 20px;
  margin-bottom: 10px;
  border: 0;
  border-radius: 9px;
  font-size: 15px;
  padding: 5px;
  height: 40px;
  width: 70px;
  max-width: 100px;
  align-self: flex-end;
  background: #387fa9;
  color: #fff;
  cursor: pointer;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }

  &:focus {
    outline: none;
  }
`;

export const UploadButton = styled.button`
  margin-top: 10px;
  margin-left: 25px;
  border: 1px solid #e0e0e0;
  border-radius: 9px;
  font-size: 15px;
  padding: 8px 12px;
  align-self: flex-start;
  background: #fff;
  color: #6c757d;
  cursor: pointer;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.95);
  }

  svg {
    margin-right: 5px;
    margin-bottom: 1px;
  }

  &:focus {
    outline: none;
  }
`;

export const ScrollCarousel = styled.div`
  padding: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 100%;
    img {
      filter: grayscale(100%);
      width: 320px;
      height: 200px;
      border-radius: 10px;
      margin: 10px 10px;
    }
  }

  @media (max-width: 720px) {
    padding: 1rem;
    div {
      img {
        width: 100%;
        margin: 10px 0px;
      }
    }
  }

  @media (max-width: 350px) {
    padding: 1rem;
    div {
      img {
        width: 250px;
        height: 180px;
        margin: 10px 0px;
      }
    }
  }
`;
